import { Component, DestroyRef, OnInit, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { AideService } from '../../aide.service';
import { AideResultat } from '../../aide.models';

/** « Que voulez-vous faire ? » : résultats au fil de la frappe, Entrée ouvre le premier. */
@Component({
  selector: 'app-aide-recherche',
  standalone: true,
  imports: [FormsModule, IconFieldModule, InputIconModule, InputTextModule],
  templateUrl: './aide-recherche.component.html',
  styleUrl: './aide-recherche.component.scss',
})
export class AideRechercheComponent implements OnInit {
  private readonly aide = inject(AideService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly saisies = new Subject<string>();

  /** Grand champ de la page /aide. */
  readonly grand = input(false);
  readonly choisir = output<string>();

  readonly requete = signal('');
  /** null : pas de recherche en cours (moins de 2 caractères). */
  readonly resultats = signal<AideResultat[] | null>(null);

  ngOnInit(): void {
    this.aide.resultats(this.saisies)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((resultats) => this.resultats.set(resultats));
  }

  saisir(valeur: string): void {
    this.requete.set(valeur);
    this.saisies.next(valeur);
  }

  valider(): void {
    const premier = this.resultats()?.[0];
    if (premier) {
      this.choisir.emit(premier.slug);
    }
  }
}
